/** Lit le payload JWT sans vérification crypto (usage local uniquement). */
export function readJwtPayload(token) {
  if (!token || typeof token !== 'string') return null;
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    const base64 = part.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join('')
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function getEntrepriseIdFromUser(user) {
  if (!user || typeof user !== 'object') return null;
  const raw = user.entreprise_id ?? user.entrepriseId ?? user.entreprise?.id ?? null;
  if (raw == null || raw === '') return null;
  return raw;
}

/** Identité employé : contexte → localStorage → JWT (après migration PG → MySQL). */
export function resolveEmployeeIdentity(user, token = null) {
  const storedToken = token || (typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null);
  let storedUser = user;
  if (!storedUser && typeof localStorage !== 'undefined') {
    try {
      const raw = localStorage.getItem('user');
      storedUser = raw ? JSON.parse(raw) : null;
    } catch {
      storedUser = null;
    }
  }

  const payload = readJwtPayload(storedToken);
  const id = storedUser?.id ?? payload?.id ?? payload?.employeeId ?? payload?.userId ?? null;
  const entrepriseId =
    getEntrepriseIdFromUser(storedUser) ??
    payload?.entreprise_id ??
    payload?.entrepriseId ??
    null;

  return {
    id,
    entrepriseId,
    user: storedUser,
  };
}

export function persistUserProfile(userData) {
  if (!userData || typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem('user', JSON.stringify(userData));
  } catch {
    /* ignore */
  }
}
